import LabelColumn, { cellType, labelColumnConfiguration } from './LabelColumn.component';

export { cellType, LabelColumn };
export default labelColumnConfiguration;
